<template>
    <div id="newMaterDelivery">
        <el-row class="clearfix" style="margin-bottom: 15px;">
            <el-col class="fl" :span="2">
                <el-button size="small"  type="warning" @click="backGo()">返回</el-button>
            </el-col>
            <el-col class="fr" :span="1">
                <i class="el-icon-refresh" style="font-size: 25px;cursor: pointer;" @click="refresh()"></i>
            </el-col>
        </el-row>
        <el-col class="fl searthPart">
            <!-- <p class="headerT">物料配送信息</p> -->
            <el-form label-width="80px" :inline="true" :label-position="labelPosition">
                <el-form-item label="接收门店:">
                <el-select v-model="returnForm.shopInput" placeholder="请选择接收门店" style="width: 100%;" clearable @change="getPicking" :disabled="returnData.length > 0">
                    <el-option v-for="(item,index) in pickingList"
                        :label="item.name"
                        :value="item.id"
                        :key="index"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="仓库类型:">
                <el-select v-model="returnForm.warehouseType" placeholder="请选择仓库类型" style="width: 100%;" clearable :disabled="returnData.length > 0">
                    <el-option v-for="(item,index) in pickingTypeList"
                        :label="item.paraName"
                        :value="item.paraCode"
                        :key="index">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="备注信息:" prop="memo">
                <el-input clearable v-model.trim="returnForm.memo" placeholder="请输入备注信息" style="margin-bottom: 15px;"></el-input>
            </el-form-item>
            <el-form-item class="fr">
                <el-button  size="small"  type="success" @click="newMater()" style="margin-bottom: 15px;margin-right: 500px">新建明细</el-button>
            </el-form-item>
        </el-form>
        </el-col>
        <el-col class="fr">
            <el-table
                :data="returnData"
                border
                :header-cell-style="{'text-align':'center'}"
                style="width: 100%"
                >
                <!-- <el-table-column
                    align="center"
                    type="index"
                    width="50"
                    label="序号">
                </el-table-column> -->
                <el-table-column
                    align="center"
                    label="操作"
                    width="50">
                    <template slot-scope="scope">
                        <el-button @click.stop="deleteRow(scope.$index, returnData)" type="text" size="small">移除</el-button>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="materialCode"
                    label="物料编号">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="modelName"
                    label="型号">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="materialName"
                    label="物料名称">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="sum"
                    label="配送数量">
                    <template slot-scope="scope">
                        <el-input-number controls-position="right" size="small" v-model="scope.row.sum" @change="changeNumber()" :min="1" :max="scope.row.availableNumber"></el-input-number>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="inboundPrice"
                    label="配送金额">
                    <template slot-scope="scope">
                        <el-input-number disabled controls-position="right" size="small" v-model="scope.row.inboundPrice" :min="0"></el-input-number>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="availableNumber"
                    label="可配送数量">
                </el-table-column>
                <el-table-column
                    align="center"
                    label="操作"
                    width="120">
                    <template slot-scope="scope">
                        <el-button @click.stop="addSerial(scope.row)" type="text" size="small">添加序列号</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="totalDiv" style="position:absolute;right:40px;top:90px;">
                <small>数量：</small>
                <strong>{{totalCount}}</strong> &nbsp;&nbsp;&nbsp;&nbsp;
            </div>
            <el-dialog title="新建物料信息" :visible.sync="dislogMater" :close-on-click-modal="false" width="800px"  @close="emptyNew()">
                <el-row>
                    <el-col>
                        <ul class="clearfix" style="margin-bottom: 15px;">
                            <span class="fl headerSpan">品牌</span>
                            <li class="fl listPart" v-for="(item,index) in brandLists" :key="index" @click="selectBrand(item,index)" v-bind:class="{active:activeBrandIndex===index}">{{item.brandName}}</li>
                        </ul>
                        <transition name="fade" mode="out-in" appear>
                            <ul class="clearfix" style="margin-bottom: 15px;" v-if="categoryLists.length !== 0 ">
                                <span class="fl headerSpan">品类</span>
                                <li @click="selectCategory(item,index)" class="fl listPart" v-for="(item,index) in categoryLists" :key="index" v-bind:class="{active:activeCategoryIndex===index}">{{item.categoryName}}</li>
                            </ul>
                        </transition>
                        <transition name="fade" mode="out-in" appear>
                            <ul class="clearfix" style="margin-bottom: 15px;" v-if="modelLists.length !== 0 ">
                                <span class="fl headerSpan">型号</span>
                                <li @click="selectModel(item,index)" v-bind:class="{active:activeModelIndex===index}" class="fl listPart" v-for="(item,index) in modelLists" :key="index">{{item.modelName}}</li>
                            </ul>
                        </transition>
                        <el-form ref="modelForm" style="width:100%;margin-bottom:20px" :inline="true" label-width="75px" :model="modelForm" :label-position="labelPosition">
                            <el-form-item style="margin-bottom:15px" label="物料编码">
                                <el-select v-model.trim="modelForm.materialCode" placeholder="请选择物料编号" @change="getMaterNumberList" clearable filterable>
                                    <el-option v-for="(item,index) in newData"
                                        :label="item.materialCode"
                                        :value="item.materialCode"
                                        :key="index">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item style="margin-bottom:15px" label="物料名称">
                                <el-select v-model.trim="modelForm.materialName" filterable @change="getMaterNumberList" placeholder="请选择物料名称"  clearable>
                                    <el-option v-for="(item,index) in newData"
                                        :label="item.materialName"
                                        :value="item.materialName"
                                        :key="index">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-row>
                <el-table
                    :data="newData"
                    border
                    :header-cell-style="{'text-align':'center'}"
                    style="width: 100%"
                    @selection-change="handleSelectionChange">
                    <el-table-column
                        align="center"
                        prop="brandName"
                        label="品牌">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="categoryName"
                        label="品类">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="modelName"
                        label="型号">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="materialCode"
                        label="物料编号">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="materialName"
                        label="物料名称">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        type="selection"
                        width="55">
                    </el-table-column>
                </el-table>
                <span slot="footer" class="dialog-footer">
                    <el-button type="success" @click="addEventFormSubmitBtn()">添加</el-button>
                    <el-button @click="emptyNew()">取 消</el-button>
                </span>
            </el-dialog>
            <el-dialog title="添加序列号"  :visible.sync="dislogSerial" :close-on-click-modal="false" width="800px"  @close="cancelSerial()">
                <el-row>
                    <el-input placeholder="请扫码或输入序列号" @input="scanCodeFuc" style="margin-bottom:20px;width:97%" v-model.trim="codeValue">
                        <template slot="prepend">序列号</template>
                    </el-input>
                    <el-transfer
                        v-model="codeList"
                        ref="myTransfer"
                        filterable
                        :left-default-checked="[]"
                        :right-default-checked="[]"
                        :render-content="renderFunc"
                        :titles="['可添加的序列号', '已添加的序列号']"
                        :button-texts="['删除', '添加']"
                        :format="{
                            noChecked: '${total}',
                            hasChecked: '${checked}/${total}'
                        }"
                        @change="handleChange"
                        :data="codeData">
                        <el-button class="transfer-footer" type="text" slot="left-footer" size="small">合计:{{codeData.length}}</el-button>
                        <el-button class="transfer-footer" type="text" slot="right-footer" size="small">已添加:{{codeList.length}}</el-button>
                    </el-transfer>
                    <div class="number-content">
                        <p>需添加序列号合计 {{unScanNumber}} 个</p>
                        <p>已添加序列号合计 {{codeList.length}} 个</p>
                        <p>可添加添加序列号 {{codeData.length}} 个</p>
                    </div>
                </el-row>
                <span slot="footer" class="dialog-footer">
                    <el-button type="success" @click="addSerialComformBtn()">添加</el-button>
                    <el-button @click="cancelSerial()">取 消</el-button>
                </span>
            </el-dialog>
            <el-button type="primary" class="fr" style="margin: 50px 20px 50px 0;" @click.native="DetermineSave()">提交</el-button>
            <el-dropdown split-button type="primary" trigger="click" class="fr" style="margin: 50px 20px 50px 0;">
                {{pageStatus}}
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="closeSave()">离开当前页面</el-dropdown-item>
                    <el-dropdown-item @click.native="goOnSave()">留在当前页面</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
            <el-button type="primary" class="fr" style="margin: 50px 20px 50px 0;" @click="cancelOrder()">取消新建</el-button>
        </el-col>
    </div>
</template>

<script>
  import {hideLoading, showLoading} from "../../components/loading/loading";

    let moment = require("moment");
    import {
        shopListNonLoginDetId,
        selectAllBrand,
        selectCategory,
        selectModel,
        getMaterialListByWarehouse,
        queryBySerialNumber,
        insertDistribution,
        selectParameterInfoBusiness
    } from "../../api/api";
    export default {
        name: 'newMaterDelivery',
        components: {
        },
        data(){
            return{
                returnForm:{
                    memo:'',
                    shopInput:'',
                    warehouseType:''
                },
                pickingList:[],         //门店列表数组
                pickingTypeList:[],     //仓库类型
                totalCount:0,           //物料总数量
                dislogMater:false,      // 新建明细弹出框
                dislogSerial:false,     //添加序列号
                defaultBrandId:'',      //品牌ID
                defaultCategoryId:'',   //品类ID
                defaultModelId:'',      //型号ID
                brandLists:'',          //品牌数组
                categoryLists:'',       //品类数组
                modelLists:'',          //型号数组
                activeBrandIndex:"",    //品牌选中下标
                activeCategoryIndex:"", //品类选中下标
                activeModelIndex:"",    //型号选中下标
                newData: [],            //新建物料明细数组
                returnData: [],         //物料明细数据数组
                pageStatus:'离开当前页面',
                saveStatus:'QR',
                codeList:[],         //已扫描序列号数组
                unScanList:[],       //待扫描序列号数组
                moreScanList:[],     //超出序列号数组
                unScanNumber:0,      //当前物料需要添加的序列号数量
                multipleSelection:[],
                materialParams:{
                    number:''        //物料序列号字符串
                },
                labelPosition:'left',
                materialId:'',
                materialCoding:'',
                codeData: [],
                amountData:[],
                renderFunc(h, option) {
                    return <span>{ option.label }</span>;
                },
                labelPosition:'left',
                codeValue:'',
                modelForm:{
                    materialCode:'',
                    materialName:''
                }
            }
        },
        created(){
            this.getShopList();
            this.getSelectParameterInfoBusiness();
        },
        methods: {
            //格式化小码codeData数据
            generateData(array){
                const data = [];
                array.forEach((item,index)=>{
                    data.push({
                        key: index,
                        label: item.code,
                        disabled: false
                    });
                })
                return data;
            },
            handleChange(value, direction, movedKeys) {

            },
            //获取门店列表
            getShopList(){
                shopListNonLoginDetId({}).then((res) => {
                  if (res.data.status == 100) {
                        this.pickingList = res.data.results.list
                  }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                  }
                }).catch((error) => {
                    this.$Message.error(error.message);
                })
            },
            //获取物料转出仓库列表
            getSelectParameterInfoBusiness(){
                let para={
                    paraType: 'warehouse_type'
                }
                selectParameterInfoBusiness(para).then(res => {
                    if (res.data.status==100) {
                        this.pickingTypeList = res.data.results.list
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            getPicking(e){
                console.log(e)
            },
            //移除订单
            deleteRow(index, rows) {
                if(rows.length > 0){
                    this.totalCount = this.totalCount - Number(rows[index].sum)
                }else{
                    this.totalCount = 0
                }
                rows.splice(index, 1);
            },
            //获取选中型号的物料数据 => 数组
            handleSelectionChange(val) {
                if(val != []){
                    this.multipleSelection = val;
                }
            },
            //添加序列号
            addSerial(row){
                console.log(row)
                this.codeList = [];   //已添加序列号数组
                this.unScanList = []; //待添加序列号数组
                this.dislogSerial = true;
                this.unScanList.push(row);
                this.unScanNumber = row.sum;    //待添加序列号个数
                this.materialId = row.materialCoding;  //当前物料编码
                this.materialCoding = row.materialCode;//当前物料编码ID
                this.queryAllSerialNumberData();       //查询所有序列号

                if(row.sn.length > 0){
                    let arr = [];
                    if(row.sn.indexOf(',') != -1){
                        arr = row.sn.split(',');
                    }else{
                        arr.push(row.sn);
                    }
                    //展示已选中的序列号
                    arr.forEach((item,index)=>{
                        this.codeData.forEach((item1,index1)=>{
                            if(item === item1.label){
                                this.codeList.push(index1);
                            }
                        })
                    })
                }
            },
            //清空添加物料明细dialogValue
            emptyNew() {
                this.dislogMater = false
            },
            scanCodeFuc(val){
                if(val.length == 8){
                    let isHave = false;
                    this.codeData.forEach((item,index)=>{
                        let isTrue = false;
                        if(item.label === val){
                            if(this.codeList.length > 0){
                                this.codeList.forEach((item1,index1)=>{
                                    if(this.codeData[item1].label === val){
                                        this.codeList.splice(index1,1);
                                        this.codeList.unshift(index);
                                        isTrue = true;
                                    }
                                })
                                if(!isTrue){
                                    this.codeList.unshift(index)
                                }
                            }else{
                                this.codeList.push(index);
                            }
                            isHave = true;
                        }
                    })
                    if(isHave){
                        this.codeValue = "";
                    }
                }
            },
            //查询序列号物料信息
            queryAllSerialNumberData(val){
                let para = {
                    number:'',
                    affiliationType:0,
                    status:1,
                    wareType:this.returnForm.warehouseType,
                    materialId:this.materialId,
                    materialCoding:this.materialCoding
                }
                queryBySerialNumber(para).then(res => {
                    if (res.data.status==100) {
                        if(res.data.results.length > 0){
                            this.codeData = this.generateData(res.data.results)
                        }else{
                            this.$message({
                                message: '您输入的序列号有误，请重新输入',
                                type: "warning"
                            });
                        }
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //提交添加序列号
            addSerialComformBtn(){
                let index = parseInt(this.codeList.length - this.unScanNumber);
                if(index != 0){
                    this.$message({
                        message: '您添加的序列号数量不等于当前需要添加的序列号数量，请核对正确再提交',
                        type: "warning"
                    });
                }else{
                    if(this.codeList.length > 0){
                        let codeList = [];
                        let amount = 0;
                        this.codeList.forEach((item,index)=>{
                            codeList.push(this.codeData[item].label);
                        });
                        codeList.forEach((item,index)=>{
                            let para = {
                                number:item,
                                affiliationType:0,
                                status:1,
                                wareType:this.returnForm.warehouseType,
                                materialId:this.materialId,
                                materialCoding:this.materialCoding
                            }
                            queryBySerialNumber(para).then(res => {
                                if (res.data.status==100) {
                                    res.data.results.forEach((item,index)=>{
                                        amount += Number(item.inboundPrice);
                                    })
                                }else{
                                    this.$message({
                                        message: res.data.message,
                                        type: "error"
                                    });
                                }
                            }).then(()=>{
                                this.returnData.forEach((item,index)=>{
                                    let arr = []
                                    codeList.forEach((item1,index1)=>{
                                        if(item.materialCode == this.unScanList[0].materialCode){
                                            arr.push(item1)
                                        }
                                    })
                                    if(arr.length > 0){
                                        item.sn = arr.join(',');
                                        item.inboundPrice = amount;
                                        this.$forceUpdate();
                                    }
                                })
                            }).catch((error) =>{
                                this.$Message.error(error.message);
                            })
                        });
                        this.cancelSerial();
                    }
                }
            },
            //取消/关闭添加序列号弹出框
            cancelSerial(){
                this.dislogSerial = false;
                this.codeList = [];
            },
            //新建物料明细
            newMater(){
                if (!this.returnForm.shopInput) {
                    this.$message({
                        message: '请选择门店再提交',
                        type: 'warning'
                    });
                    return
                }
                if (!this.returnForm.warehouseType) {
                    this.$message({
                        message: '请选择仓库类型再提交',
                        type: 'warning'
                    });
                    return
                }
                this.dislogMater = true;
                if(this.brandLists.length == 0 || this.returnData.length == 0){
                    this.getBrandLists();
                }
            },
            //查询品牌or获取品牌
            getBrandLists() {
                selectAllBrand().then(res => {
                    if (res.data.status==100) {
                        this.brandLists = res.data.results;
                        this.defaultBrandId = res.data.results[0].brandId;
                        this.activeBrandIndex = 0;
                        this.getCategoryList(this.defaultBrandId);
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //选中品牌
            selectBrand(item,index) {
                this.activeBrandIndex = index;
                this.defaultBrandId = Object.assign({}, item).brandId;
                this.getCategoryList(this.defaultBrandId);
                this.newData = [];
            },
            //获取品类
            getCategoryList(id){
                const brandId = id
                const brandData = {brandId:brandId}
                selectCategory(brandData).then((res) => {
                  if (res.data.status == 100) {
                        this.categoryLists = res.data.results;
                        this.defaultCategoryId = res.data.results[0].categoryId;
                        this.activeCategoryIndex = 0;
                        this.getModelList(this.defaultBrandId,this.defaultCategoryId);
                  }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                  }
                }).catch((error) => {
                    this.$Message.error(error.message);
                })
            },
            //选中品类
            selectCategory(item,index) {
                this.activeCategoryIndex = index;
                this.defaultCategoryId = Object.assign({}, item).categoryId;
                this.getModelList(this.defaultBrandId,this.defaultCategoryId);
            },
            //获取型号
            getModelList(id1,id2){
                let para = {
                    brandId:id1,
                    categoryId:id2,
                }
                selectModel(para).then(res => {
                    if (res.data.status==100) {
                        this.modelLists = res.data.results;
                        this.defaultModelId = res.data.results[0].modelId;
                        this.activeModelIndex = 0;
                        this.getMaterNumberList();
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //选中型号
            selectModel(item,index) {
                this.activeModelIndex = index
                this.defaultModelId = Object.assign({}, item).modelId
                this.getMaterNumberList()
            },
            //获取物料编号
            getMaterNumberList(){
                let para={
                   brandId: this.defaultBrandId,
                   categoryId:this.defaultCategoryId,
                   modelId: this.defaultModelId,
                   warehouseType:this.returnForm.warehouseType,
                   materialCode:this.modelForm.materialCode,
                   materialName:this.modelForm.materialName
                }
                getMaterialListByWarehouse(para).then(res => {
                    if (res.data.status==100) {
                        this.newData = res.data.results
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //提交添加明细
            addEventFormSubmitBtn() {
                let isHave = false;
                let isArray = [];
                let isThere = [];
                if(this.returnData.length == 0){
                    this.multipleSelection.forEach((item2,index2,array) =>{
                        if(array.indexOf(item2) === index2) {
                            this.returnData.unshift({
                                materialCode: item2.materialCode,
                                materialCoding:item2.materialCoding,
                                materialName: item2.materialName,
                                sum:1,
                                sn:'',
                                modelId:item2.modelId,
                                modelName:item2.modelName,
                                availableNumber:item2.availableNumber,
                                inboundPrice:0
                            })
                        }
                    })
                }else{
                    this.multipleSelection.forEach((item,index)=>{
                        isHave = false;
                        this.returnData.forEach((item1,index1)=>{
                            if(item.materialCode == item1.materialCode){
                                isHave = true;
                                isThere.push(item.materialName);
                            }
                        })
                        if(!isHave){
                            isArray.push(item);

                        }
                    });
                    isArray.forEach((item,index)=>{
                        this.returnData.unshift({
                            materialCode: item.materialCode,
                            materialCoding:item.materialCoding,
                            materialName: item.materialName,
                            sum:1,
                            sn:'',
                            modelId:item.modelId,
                            modelName:item.modelName,
                            availableNumber:item.availableNumber,
                            inboundPrice:0
                        })
                    })
                }
                this.getAllMoney() //计算总数
                this.dislogMater = false;
                if(isThere.length > 0){
                    let materialStr = isThere.join('、');
                    this.$message({
                        message: "列表中已存"+materialStr+"，请手动输入数量",
                        type: "warning"
                    });
                }
            },
            changeNumber(){
                this.getAllMoney();
            },
            // 汇总数量和金额
            getAllMoney() {
                this.totalCount = 0
                if (this.returnData) {
                    this.returnData.forEach(element => {
                        this.totalCount += element.sum
                    })
                }
            },
            //返回上一页
            backGo() {
                this.$router.push({
                    path:'/materDeliveryManage'
                })
            },
            tabRemove (targetName) {
                // 首页不可删除
                if(targetName == '/') {
                    return;
                }
                //将该tab从options里移除
                this.$store.commit('delete_tabs', targetName);
              ////还同时需要处理一种情况当需要移除的页面为当前激活的页面时，将上一个tab页作为激活tab
                if (this.activeIndex === targetName) {
                    // 设置当前激活的路由
                    if (this.options && this.options.length >= 1) {
                        this.$store.commit('set_active_index', this.options[this.options.length-1].route);
                        this.$router.push({path: this.activeIndex});
                    } else {
                        this.$router.push({path: '/welcome'});
                    }
                }
            },
            //金额转化函数
            addCommas:function(row,column){
                var num = row[column.property];
                //var b= num.toString().replace(/\$|\,/g,'');
                if(isNaN(num))
                num = "0";
                var sign = (num == (num = Math.abs(num)));
                num = Math.floor(num*100+0.50000000001);
                var cents = num%100;
                num = Math.floor(num/100).toString();
                if(cents<10)
                cents = "0" + cents;
                for (var i = 0; i < Math.floor((num.length-(1+i))/3); i++)
                num = num.substring(0,num.length-(4*i+3))+','+
                num.substring(num.length-(4*i+3));
                return (((sign)?'':'-') + num + '.' + cents);
            },
            //提交
            DetermineSave(){
                this.saveStatus = 'YQR';
                if (!this.returnForm.shopInput) {
                    this.$message({
                        message: '请选择门店再提交',
                        type: 'warning'
                    });
                    return
                }
                if (!this.returnForm.warehouseType) {
                    this.$message({
                        message: '请选择仓库类型再提交',
                        type: 'warning'
                    });
                    return
                }
                if(this.returnData.length == 0){
                    this.$message({
                        message: '请新建物料明细并选择，再提交',
                        type: 'warning'
                    });
                }else{
                    let materialNameList = [];
                    let isEqual = [];
                    this.returnData.forEach((item,index)=>{
                        if(item.sn == ''){
                            materialNameList.push(item.materialName);
                        }else{
                            if(item.sn.split(',').length != item.sum){
                                isEqual.push(item.materialName)
                            }
                        }
                    })
                    //判断是否添加序列号
                    if(materialNameList.length > 0){
                        let materialStr = materialNameList.join('、');
                        this.$message({
                            message: materialStr+'未添加序列号，请添加后再提交',
                            type: 'warning'
                        });
                        return;
                    }
                    //判断是否添加序列号与转库数量是否相等
                    if(isEqual.length > 0){
                        let equalStr = isEqual.join('、');
                        this.$message({
                            message: isEqual+'部分序列号未添加，请添全部加序列号后再提交',
                            type: 'warning'
                        });
                        return
                    }
                    let para={
                        shopInput:this.returnForm.shopInput,
                        memo:this.returnForm.memo,
                        sum:this.totalCount,
                        distributionDetails: this.returnData,
                        warehouseType:this.returnForm.warehouseType
                    };
                    showLoading();
                    insertDistribution(para).then(res => {
                      hideLoading();
                      if (res.data.status==100) {
                            this.$message({
                                message: res.data.message,
                                type: "success"
                            });
                            if (this.pageStatus == '离开当前页面') {
                                this.tabRemove(this.$route.path);
                                this.$router.replace({
                                    path:'/materDeliveryManage'
                                })
                            }
                            this.refresh();
                        }else{
                            this.$message({
                                message: res.data.message,
                                type: "error"
                            });
                        }
                    }).catch((error) =>{
                        this.$Message.error(error.message);
                    })

                }

            },
            refresh(){
                this.returnForm.shopInput = '';
                this.returnForm.memo = '';
                this.returnData = [];
                this.returnForm.warehouseType = '';
                this.multipleSelection = [];
                this.totalCount = 0;
            },
            closeSave(){
                this.pageStatus = "离开当前页面"
            },
            goOnSave(){
                this.pageStatus = "留在当前页面"
            },
            //取消新建
            cancelOrder(){
                this.tabRemove(this.$route.path)
                this.$router.replace({
                    path:'/materDeliveryManage'
                })
            }
        },
        computed: {

        },
        watch: {

        }

  }
</script>

<style type="text/css" lang="scss">
    .el-transfer-panel__body{
        .el-transfer-panel__list{
            height:160px!important;
        }
    }
</style>
<style type="text/css" lang="scss" scoped>
    #newMaterDelivery{
        font-size: 14px;
        .searthPart{.el-input{width: 100%;}}
        .headerT{font-size: 16px;margin:0 0 15px 0;}
        .headerSpan{
            margin-right:20px
        }
        .transfer-footer {
            margin-left: 20px;
            padding: 6px 5px;
        }

        .number-content{
            padding:30px 0 !important;
            p{
                text-align:left;
                color:#666;
                font-size:14px;
            }
        }
        .listPart{border:1px solid #c6c6c6;margin:-8px 15px 18px 0;border-radius: 5px;text-align: center;position: relative;z-index: 0;cursor: pointer;padding: 5px 10px;}
        li.active{background-color:#1abc9c;color:#fff;border-color: #1abc9c;}
        .activeBtn{background-color: #1abc9c;color:#fff;}
        .el-step__line{background-color: #1abc9c;}
        .el-step__icon-inner{color:#1abc9c;}
        .el-step__icon.is-text{border-color: #1abc9c;}
        .totalDiv{
            height: auto;
            overflow: hidden;
            text-align: right;
            font-size: 16px;
            background-color: #fff;
            border-bottom: 1px solid #e5e9f2;
            padding: 10px;
        }
        .scanTitle{
            display:block;
            margin:10px
        }
    }

</style>



// WEBPACK FOOTER //
// newMaterDelivery.vue?8d589f24